import { Platform } from 'react-native';
import Alert from '../components/Alert';

export function confirmAction(title, message) {
  if (Platform.OS === 'web') return Promise.resolve(window.confirm(message));
  return new Promise(resolve => {
    Alert.alert(title, message, [
      { text: 'Cancel', onPress: () => resolve(false), style: 'cancel' },
      { text: 'Confirm', onPress: () => resolve(true), style: 'destructive' },
    ]);
  });
}
